// 店側が読み込む唯一のスクリプト。
//
// おちゃのこ各店のフリーページに置くのは、この2行だけ:
//   <div data-wu-widget="order-status" data-site="1"></div>
//   <script src="https://front.workup-system.com/w/storefront.js" defer></script>
//
// ページに何個ウィジェットが載っても <script> は1本。ここで [data-wu-widget] を全部拾い、
// 名前に対応するウィジェットを mount する。

import { mountAll } from './shared/registry'
import { getSiteInfoId } from './shared/site-id'
import { runHooks } from './shared/hooks'

declare global {
  interface Window {
    wu?: { siteInfoId: number | null }
  }
}

function boot(): void {
  const siteId = getSiteInfoId()
  window.wu = { siteInfoId: siteId }

  mountAll(document)
  runHooks(siteId)
}

// defer で読ませる前提だが、フリーページ本文の途中に素で置かれる可能性も残る。
// どちらでも動くように、DOM の準備状況を見て入口を分ける。
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
